import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://foodsapi.aapkabazar.co/api",
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const pincode = localStorage.getItem("pincode");
  if (pincode) config.headers["X-Pincode"] = pincode;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
